import React from 'react';
import PropTypes from 'prop-types';
import RoleAwareLink from '../../common/RoleAwareLink';
import Icon, { GLYPHS } from '../../common/icon';
import { t } from '../../../modules/infra/i18n';

const BackButton = ({ to }) => (
  <RoleAwareLink to={to} className="c-btn c-btn--blank c-btn--medium large-and-up-ph+">
    <Icon glyph={GLYPHS.back} size="small" />
    <span className="u-ml-">{t('engage:back_button')}</span>
  </RoleAwareLink>
);
BackButton.propTypes = {
  to: PropTypes.string.isRequired,
};

export default BackButton;
